// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"676":"134399ab","970":"fc59184f"}[chunkId] + ".chunk.js";
};